import { cn } from "@/lib/utils";

/**
 * Sidetopp: valfri «eyebrow», tittel, kort skildring og handlingar.
 * Mobil: handlingar under tittelen i full breidd. Desktop: til høgre, botnjustert med tittelen.
 */
export const PageHeader = ({ eyebrow, title, description, actions, children, className, testId = "page-header" }) => (
  <div className={cn("flex flex-col gap-4", className)} data-testid={testId}>
    <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div className="min-w-0">
        {eyebrow ? <p className="eyebrow mb-1.5">{eyebrow}</p> : null}
        <h1 className="text-[22px] font-semibold leading-[1.15] md:text-[26px]">{title}</h1>
        {description ? <p className="mt-1 max-w-2xl text-sm leading-6 text-muted-foreground">{description}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
    {children}
  </div>
);
